export let wednesdayUppercase = "INqPRe";
export default {wednesdayUppercase};